// Commerce connector API is called in all our pes pages
export const SPRYKER_COMMERCE_CONNECTOR_PATH = '/commerce-connector';

// product card main and secondary API is used called in range ,category listing and comparision pages.
export const SPRYKER_PRODUCT_CARD_MAIN_PATH = '/products-card/main';
export const SPRYKER_PRODUCT_CARD_SECONDARY_PATH = '/products-card/secondary';

export const SPRYKER_PRODUCTS_ALL_PATH = '/products/#product_id#/all';
export const SPRYKER_DDC_CONFIG_PATH = '/ddc-config';

// My products is called in range and pdp and also in category and subcategory listing products
export const SPRYKER_MY_PRODUCTS_REST_URL = '/my-products';

export const SPRYKER_ANALYTICS_LOOKUPS = '/analytics';

export const SPRYKER_PRODUCTS_SUBSTITUTION = '/products-substitution';
